// extracted by mini-css-extract-plugin
export default {"table":"BalanceList_table__B8-Dq","font":"BalanceList_font__G4NW3","h2":"BalanceList_h2__pLnwU"};